var exports = {
  "As": "AccordionItem__DclCXM",
  "c4": "AccordionItem__heading__R9lu4h",
  "Zw": "AccordionItem__content__1uGao4",
  "SH": "AccordionItem__content--expanded__ARSVhw",
};

module.exports = exports;
